import { gql, useMutation } from '@apollo/client';

const CREATE_CHAT_MESSAGE_MUTATION = gql`
  mutation createChatMessage($chatSessionId: ID!, $message: String!) {
    createChatMessage(chatSessionId: $chatSessionId, message: $message) {
      id
      role
      content
      status
      createdAt
      updatedAt
      chatSession {
        id
      }
    }
  }
`;
export const useCreateMessage = () => {
  const [createChatMessage] = useMutation(CREATE_CHAT_MESSAGE_MUTATION, {
    errorPolicy: 'all',
  });

  const sendMessage = async (chatSessionId, message) => {
    if (!chatSessionId || !message?.trim()) {
      throw new Error('Chat session ID and message content are required');
    }

    return await createChatMessage({
      variables: {
        chatSessionId,
        message,
      },
    });
  };

  return sendMessage;
};
